import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class StartSellingService {
  showStartSellingPopup = new Subject<void>()

  constructor() {}

  notify() {
    this.showStartSellingPopup.next()
  }
}
